import { NervaUserData } from 'hydra-data-types';
import { INSURANCE_TYPE_PUBLIC } from '../config/InsuranceProviders';
import { StoreStateInternal } from '../store/Store';
import {
  isDirectMedicareFlow,
  isEligibleForFree65Access,
  isMedicareOriginal,
  isUsNon65Plus,
} from './MedicareAccess';

/** Returns the key for screens that should bypass insurance for CMS access users. */
function getFreeAccessRoute(state: StoreStateInternal): 'freeAccess' | undefined {
  return isEligibleForFree65Access(state) === true ? 'freeAccess' : undefined;
}

/**
 * Routes the MaintenanceExperience screen in the Control (direct, non-referred) flow. Medicare
 * Original enters the CMS-Access PROMs branch; D2C 65+ users who aren't Original can't join CMS
 * Access, so they get the "coverage results" (20% discount) screen; US non-65+ users collect their
 * insurance (the coverage flow) before paying; everyone else keeps the existing free-access /
 * payment path.
 */
function getMaintenanceExperienceRoute(
  state: StoreStateInternal
): 'medicareOriginal' | 'notCovered' | 'freeAccess' | 'collectCoverage' | undefined {
  if (isMedicareOriginal(state)) return 'medicareOriginal';
  if (isDirectMedicareFlow(state) === true) return 'notCovered';
  if (isUsNon65Plus(state)) return 'collectCoverage';
  return getFreeAccessRoute(state);
}

/** Returns true if the user has insurance coverage (real insurer, "not listed", or public program). */
function getHasInsuranceCoverage(state: StoreStateInternal): boolean {
  const providerAnswers = (state.userData as NervaUserData)['insuranceProvider'];
  const hasRealInsurer = Array.isArray(providerAnswers) && providerAnswers.length > 0;

  const typeAnswers = (state.userData as Record<string, unknown>)['insuranceType'];
  const hasPublicProgram = Array.isArray(typeAnswers) && typeAnswers[0] === INSURANCE_TYPE_PUBLIC;

  return hasRealInsurer || hasPublicProgram;
}

export const InsuranceSelectors = {
  getFreeAccessRoute,
  getMaintenanceExperienceRoute,
  getHasInsuranceCoverage,
};
